import { AppConstants } from '../../../../app.constants';
import { BehaviorScreen } from './screen.type';

export class UpdateMonitorImageResolutionViewModel {
    machinePhysicalAddress: string;
    monitorHandler: string;
    imageResolutionWidth: number;
    imageResolutionHeight: number;

    constructor(
        monitor: BehaviorScreen,
        imageResolutionHeight = AppConstants.DEFAULT_MONITOR_IMAGE_HEIGHT,
        imageResolutionWidth = AppConstants.DEFAULT_MONITOR_IMAGE_WIDTH
    ) {
        this.machinePhysicalAddress = monitor.MachinePhysicalAddress;
        this.monitorHandler = monitor.MonitorHandler;
        this.imageResolutionHeight = imageResolutionHeight;
        this.imageResolutionWidth = imageResolutionWidth;
    }
}
